var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ayeqnjaat)",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.18 15.51 28 10l9.82 5.51-3.6 2.04L28 14.07l-6.21 3.48-3.61-2.04Zm19.64 6.96-3.6-2.04L28 23.91l-6.21-3.48-3.61 2.04v4.07l6.2 3.48v6.95L28 39.01l3.61-2.04v-6.95l6.21-3.48v-4.07Zm0 11.03v-4.08l-3.6 2.04v4.07l3.6-2.03Zm2.57 1.44-6.21 3.47v4.08L44 36.97V25.95l-3.61 2.03v6.96Zm-3.61-15.95 3.6 2.04v4.07L44 23.07v-4.08l-3.61-2.04L36.78 19Zm-12.4 20.9v4.07L28 46l3.61-2.04V39.9L28 41.93l-3.61-2.04Zm-6.2-6.4 3.6 2.04v-4.07l-3.6-2.04v4.08Zm6.2-14.5L28 21.03l3.61-2.04L28 16.95 24.39 19Zm-8.77 2.04 3.61-2.04-3.6-2.04L12 19v4.08l3.61 2.03v-4.07Zm0 6.95L12 25.95v11.02l9.82 5.52V38.4l-6.2-3.47v-6.96Z",
    fill: "#F0B90B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ayeqnjaat",
    x1: 10.42,
    y1: 9.71,
    x2: 68.15,
    y2: 76.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06060A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.a2126418f0cb84ad2e96dab0cfc8dfe3.svg";
export { ForwardRef as ReactComponent };